module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"not-found-msg":"We are sorry, but we couldn\u0027t find {url}."},"de":{"not-found-msg":"Tut uns leid, aber wir konnten {url} nicht finden."}}')
  delete Component.options._Ctor
}
